import { takeLatest } from 'redux-saga/effects';
import { VEHICLE_GET_VEHICLE_DATA_REQUEST, VEHICLE_GET_VEHICLE_META_DATA_REQUEST, VEHICLE_SAVE_VEHICLE_DATA_REQUEST, VEHICLE_UPDATE_VEHICLE_DATA_REQUEST } from '../actions';
import { getJobVehicleSaga } from './getJobVehicleSaga';
import { getVehicleMetaDataSaga } from './getVehicleMetaDataSaga';
import { saveJobVehicleSaga } from './saveJobVehicleSaga';
import { updateJobVehicleSaga } from './updateJobVehicleSaga';
export function* vehicleRootSaga() {
    yield takeLatest(VEHICLE_GET_VEHICLE_DATA_REQUEST, getJobVehicleSaga);
    yield takeLatest(VEHICLE_GET_VEHICLE_META_DATA_REQUEST, getVehicleMetaDataSaga);
    yield takeLatest(VEHICLE_SAVE_VEHICLE_DATA_REQUEST, saveJobVehicleSaga);
    yield takeLatest(VEHICLE_UPDATE_VEHICLE_DATA_REQUEST, updateJobVehicleSaga);
}
//# sourceMappingURL=vehicleRootSaga.js.map